export default __webpack_public_path__ + "583c03d61e54d9c4ed33faf0bff4adb2.png";